<template>
  <section>
    <div id="outer-box" class="outer-box-map">
      <p class="title">
        <span class="s1">客户地图:</span>
        <span class="s2" @click="showAreaTree">{{
          areaName != null && areaName.length == 0 ? "请选择地区" : areaName
        }}</span>
      </p>
      <div id="panel" class="scrollbar1 hide">
        <ul id="area-tree"></ul>
      </div>
      <div id="container" tabindex="0"></div>
      <div class="colorList">
        <div class="colorItem colorListTitleItem">
          <div class="colorv"></div>
          <div class="colorListTitle">客户数:</div>
        </div>
        <div class="colorItem" v-for="(item, index) in colorList" :key="index">
          <div class="colorv" :style="{ background: item.color }"></div>
          <div v-if="item.max == '-'" class="colorn">>={{ item.min }}</div>
          <div v-else class="colorn">{{ item.min }}~{{ item.max }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MapLoader from "./amap.js";
export default {
  name: "test",
  data() {
    return {
      $: null,
      areaName: "",
      mapData: [],
      canInitPage: false,
      colorList: [
        { min: 51, max: "-", color: "#00B050" },
        { min: 31, max: 50, color: "#558ED5" },
        { min: 21, max: 30, color: "#CCC1DA" },
        { min: 11, max: 20, color: "#00B0F0" },
        { min: 6, max: 10, color: "#FCD5B5" },
        { min: 0, max: 5, color: "#FF3505" }
      ],
      isLastAreaNode: false
    };
  },
  mounted() {
    // let that = this;
    // let timer = setInterval(() => {
    //   if (that.canInitPage) {
    //     clearInterval(timer);
    //   }
    // }, 100);
    this.initMap();
  },
  methods: {
    intoDetail(code) {
      this.$router.push({
        path: "/mapDetailList",
        query: {
          code: code,
          queryType: 1
        }
      });
    },
    showAreaTree() {
      this.$("#panel").removeClass("hide");
    },
    getColorValue(adcode) {
      let color = "";
      for (let i = 0; i < this.mapData.length; i++) {
        let currentValue = this.mapData[i];
        if (Number(currentValue.adcode) === Number(adcode)) {
          let cnt = Number(currentValue.cnt);
          for (let j = 0; j < this.colorList.length; j++) {
            let colorItem = this.colorList[j];
            if (j === 0 && colorItem.min <= cnt) {
              color = colorItem.color;
            } else if (colorItem.min <= cnt && colorItem.max >= cnt) {
              color = colorItem.color;
              // eslint-disable-next-line no-empty
            } else {
            }
          }
        }
      }
      if (color == "") {
        color = this.colorList[this.colorList.length - 1].color;
      }
      return color;
    },
    mapCodeChange(code) {
      this.$emit("mapCodeChange", code);
    },
    async initMap() {
      let that = this;
      await MapLoader().then(AMap => {
        //创建地图
        var map = new AMap.Map("container", {
          zoom: 4,
          resizeEnable: false,
          layers: [
            new AMap.DistrictLayer.Country({
              SOC: "CHN"
            })
          ]
        });

        map.on("complete", function() {});

        // eslint-disable-next-line no-undef
        AMapUI.load(["ui/geo/DistrictExplorer", "lib/$"], async function(
          DistrictExplorer,
          $
        ) {
          that.$ = $;
          //创建一个实例
          var districtExplorer = (window.districtExplorer = new DistrictExplorer(
            {
              eventSupport: true, //打开事件支持
              map: map
            }
          ));

          //当前聚焦的区域
          var currentAreaNode = null;

          //鼠标hover提示内容
          var $tipMarkerContent = $('<div class="tipMarker top"></div>');

          var tipMarker = new AMap.Marker({
            content: $tipMarkerContent.get(0),
            offset: new AMap.Pixel(0, 0),
            bubble: true
          });

          //根据Hover状态设置相关样式
          // eslint-disable-next-line no-unused-vars
          function toggleHoverFeature(feature, isHover, position) {
            tipMarker.setMap(isHover ? map : null);

            if (!feature) {
              return;
            }

            var props = feature.properties;

            if (isHover) {
              //更新提示内容
              // $tipMarkerContent.html(props.adcode + ": " + props.name);
              //更新位置
              // tipMarker.setPosition(position || props.center);
            }

            $("#area-tree")
              .find('h2[data-adcode="' + props.adcode + '"]')
              .toggleClass("hover", isHover);

            //更新相关多边形的样式
            var polys = districtExplorer.findFeaturePolygonsByAdcode(
              props.adcode
            );
            for (var i = 0, len = polys.length; i < len; i++) {
              polys[i].setOptions({
                // fillOpacity: isHover ? 0.5 : 0.35,
              });
            }
          }

          //监听feature的hover事件
          districtExplorer.on("featureMouseout featureMouseover", function(
            e,
            feature
          ) {
            toggleHoverFeature(
              feature,
              e.type === "featureMouseover",
              e.originalEvent ? e.originalEvent.lnglat : null
            );
          });

          //监听鼠标在feature上滑动
          // eslint-disable-next-line no-unused-vars
          districtExplorer.on("featureMousemove", function(e, feature) {
            //更新提示位置
            tipMarker.setPosition(e.originalEvent.lnglat);
          });

          //feature被点击
          districtExplorer.on("featureClick", function(e, feature) {
            var props = feature.properties;
            let childrenNum = props.childrenNum;
            if (childrenNum === 0 && that.isLastAreaNode) {
              that.intoDetail(props.adcode);
            } else {
              if (childrenNum === 0) {
                that.isLastAreaNode = true;
              } else {
                that.isLastAreaNode = false;
              }
              switch2AreaNode(props.adcode);
            }
          });

          //外部区域被点击
          districtExplorer.on("outsideClick", function(e) {
            districtExplorer.locatePosition(
              e.originalEvent.lnglat,
              function(error, routeFeatures) {
                if (routeFeatures && routeFeatures.length > 1) {
                  //切换到省级区域
                  switch2AreaNode(routeFeatures[1].properties.adcode);
                } else {
                  //切换到全国
                  switch2AreaNode(100000);
                }
              },
              {
                levelLimit: 2
              }
            );
          });

          //绘制区域面板的节点
          function renderAreaPanelNode(ele, props, color) {
            var $box = $("<li/>").addClass("lv_" + props.level);

            var $h2 = $("<h2/>")
              .addClass("lv_" + props.level)
              .attr({
                "data-adcode": props.adcode,
                "data-level": props.level,
                "data-children-num": props.childrenNum || void 0,
                "data-center": props.center.join(",")
              })
              .html(props.name)
              .appendTo($box);

            if (color) {
              $h2.css("borderColor", color);
            }

            //如果存在子节点
            if (props.childrenNum > 0) {
              //显示隐藏
              $('<div class="showHideBtn"></div>').prependTo($box);

              //子区域列表
              $("<ul/>")
                .addClass("sublist lv_" + props.level)
                .appendTo($box);

              $('<div class="clear"></div>').appendTo($box);

              if (props.level !== "country") {
                $box.addClass("hide-sub");
              }
            } else {
              $('<div class="showHideBtnEm"></div>').prependTo($box);
            }

            $box.appendTo(ele);
          }

          //填充某个节点的子区域列表
          function renderAreaPanel(areaNode) {
            var props = areaNode.getProps();
            var $subBox = $("#area-tree")
              .find('h2[data-adcode="' + props.adcode + '"]')
              .siblings("ul.sublist");

            if (!$subBox.length) {
              //父节点不存在，先创建
              renderAreaPanelNode($("#area-tree"), props);
              $subBox = $("#area-tree").find("ul.sublist");
            }
            if ($subBox.attr("data-loaded") === "rendered") {
              return;
            }

            $subBox.attr("data-loaded", "rendered");

            var subFeatures = areaNode.getSubFeatures();

            //填充子区域
            for (var i = 0, len = subFeatures.length; i < len; i++) {
              let adcode = subFeatures[i].properties.adcode;
              let colorValue = that.getColorValue(adcode);
              renderAreaPanelNode(
                $subBox,
                areaNode.getPropsOfFeature(subFeatures[i]),
                colorValue
              );
            }
          }

          //绘制某个区域的边界
          function renderAreaPolygons(areaNode) {
            //更新地图视野
            map.setBounds(areaNode.getBounds(), null, null, true);

            //清除已有的绘制内容
            districtExplorer.clearFeaturePolygons();

            //绘制子区域
            // eslint-disable-next-line no-unused-vars
            districtExplorer.renderSubFeatures(areaNode, function(feature, i) {
              // console.log("feature ,i", feature, i);
              // var fillColor = colors[i % colors.length];
              let fillColor = that.getColorValue(feature.properties.adcode);
              // eslint-disable-next-line no-unused-vars
              let strokeColor = that.getColorValue(feature.properties.adcode);
              return {
                cursor: "default",
                bubble: true,
                strokeColor: "black", //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 0.3, //线宽
                fillColor: fillColor, //填充色
                fillOpacity: 1 //填充透明度
              };
            });

            //绘制父区域
            let fillColorP = undefined;
            if (areaNode.getSubFeatures().length === 0) {
              fillColorP = that.getColorValue(areaNode.adcode);
              if (!fillColorP) {
                fillColorP = that.colorList[that.colorList.length - 1].color;
              }
            }
            districtExplorer.renderParentFeature(areaNode, {
              cursor: "default",
              bubble: true,
              strokeColor: "black", //线颜色
              strokeOpacity: 1, //线透明度
              strokeWeight: 0.3, //线宽
              fillColor: fillColorP,
              fillOpacity: 1 //填充透明度
            });

            $(".tipMarker.top.areaNodeName").remove();

            function addLableName(props) {
              var $tipMarkerContent = $(
                '<div class="tipMarker top areaNodeName"></div>'
              );
              var tipMarker = new AMap.Marker({
                content: $tipMarkerContent.get(0),
                offset: new AMap.Pixel(0, 0),
                bubble: true
              });
              tipMarker.setMap(map);
              //更新提示内容
              let cnt = 0;
              for (let i = 0; i < that.mapData.length; i++) {
                let currentValue = that.mapData[i];
                if (Number(currentValue.adcode) === Number(props.adcode)) {
                  cnt = currentValue.cnt;
                  break;
                }
              }
              let tipMarkHtml = props.name + ":" + cnt;

              // that.mapData.filter(function (currentValue, index) {
              //   if (Number(currentValue.adcode) === Number(props.adcode)) {
              //     tipMarkHtml = tipMarkHtml + ":" + currentValue.cnt;
              //   }
              // });
              $tipMarkerContent.html(tipMarkHtml);
              //更新位置
              if (!props.centroid) {
                tipMarker.setPosition(props.center);
              } else {
                tipMarker.setPosition(props.centroid);
              }
            }

            // 显示区域名
            if (areaNode.getSubFeatures().length == 0) {
              addLableName(areaNode.getProps());
            } else {
              let areaNodeList = areaNode.getSubFeatures();
              for (let i = 0; i < areaNodeList.length; i++) {
                addLableName(areaNodeList[i].properties);
              }
            }
          }

          //切换区域后刷新显示内容
          function refreshAreaNode(areaNode) {
            districtExplorer.setHoverFeature(null);

            renderAreaPolygons(areaNode);

            //更新选中节点的class
            var $nodeEles = $("#area-tree").find("h2");

            $nodeEles.removeClass("selected");

            var $selectedNode = $nodeEles
              .filter("h2[data-adcode='" + areaNode.getAdcode() + "']")
              .addClass("selected");

            // debugger
            that.areaName = $selectedNode.html();

            //展开下层节点
            $selectedNode.closest("li").removeClass("hide-sub");

            //折叠下层的子节点
            $selectedNode
              .siblings("ul.sublist")
              .children()
              .addClass("hide-sub");
          }

          //切换区域
          async function switch2AreaNode(adcode, callback) {
            let paramAdCode = Number(adcode) === 100000 ? "000000" : adcode;
            that.mapCodeChange(paramAdCode);
            let mapData = await that.getMapData(paramAdCode);
            that.mapData = mapData.data.data;
            if (
              currentAreaNode &&
              "" + currentAreaNode.getAdcode() === "" + adcode
            ) {
              return;
            }

            loadAreaNode(adcode, function(error, areaNode) {
              if (error) {
                if (callback) {
                  callback(error);
                }

                return;
              }

              currentAreaNode = window.currentAreaNode = areaNode;

              //设置当前使用的定位用节点
              districtExplorer.setAreaNodesForLocating([currentAreaNode]);

              refreshAreaNode(areaNode);

              if (callback) {
                callback(null, areaNode);
              }
            });
          }

          //加载区域
          function loadAreaNode(adcode, callback) {
            districtExplorer.loadAreaNode(adcode, function(error, areaNode) {
              if (error) {
                if (callback) {
                  callback(error);
                }

                console.error(error);

                return;
              }

              renderAreaPanel(areaNode);

              if (callback) {
                callback(null, areaNode);
              }
            });
          }

          $("#area-tree").on(
            "mouseenter mouseleave",
            "h2[data-adcode]",
            function(e) {
              if (e.type === "mouseleave") {
                districtExplorer.setHoverFeature(null);
                return;
              }

              var adcode = $(this).attr("data-adcode");

              districtExplorer.setHoverFeature(
                currentAreaNode.getSubFeatureByAdcode(adcode)
              );
            }
          );

          $("#area-tree").on("click", "h2", async function() {
            var adcode = $(this).attr("data-adcode");
            that.areaName = $(this).html();
            $("#panel").addClass("hide");
            if (
              $(this)
                .parent()
                .find("li").length > 0
            ) {
              that.isLastAreaNode = false;
            } else {
              that.isLastAreaNode = true;
            }
            switch2AreaNode(adcode);
          });

          $("#area-tree").on("click", ".showHideBtn", function() {
            var $li = $(this).closest("li");

            $li.toggleClass("hide-sub");

            if (!$li.hasClass("hide-sub")) {
              //子节点列表被展开
              var $subList = $li.children("ul.sublist");

              //尚未加载
              if (!$subList.attr("data-loaded")) {
                $subList.attr("data-loaded", "loading");

                $li.addClass("loading");

                //加载
                loadAreaNode(
                  $li.children("h2").attr("data-adcode"),
                  function() {
                    $li.removeClass("loading");
                  }
                );
              }
            }
          });

          //全国
          switch2AreaNode(100000);
        });
      });
    },
    getMapData(code) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        this.$common
          .http({
            mt: "post",
            url: "/wxapi/distributor/load_map",
            data: { code: code }
          })
          .then(res => {
            resolve(res);
          });
      });
    }
  },
  async created() {
    // let mapData = await this.getMapData("000000");
    // this.mapData = mapData.data.data;
    // this.canInitPage = true;
  }
};
</script>
<style lang="less" scope>
#outer-box {
  .hide {
    display: none;
  }
  .title {
    padding: 10px 15px;
    display: flex;
    .s1 {
      font-size: 16px;
      color: #4a4a4a;
      padding-right: 15px;
      display: inline-block;
      line-height: 25px;
    }
    .s2 {
      background: rgba(0, 0, 0, 0.05);
      border: 0 solid #d7dade;
      border-radius: 2px;
      text-align: center;
      height: 25px;
      width: calc(100vw - 150px);
      display: inline-block;
      font-size: 12px;
      line-height: 25px;
      color: #9b9b9b;
    }
  }
  .colorList {
    display: flex;
    font-size: 10px;
    padding: 10px 0px 0px 0px;
    .colorListTitle {
      color: #7f7f7f;
      text-align: right;
    }
    .colorItem {
      color: #7f7f7f;
      padding-left: 5px;
      .colorv {
        width: 38px;
        height: 8px;
      }
      .colorn {
        text-align: left;
      }
    }
  }
}
</style>
<style>
#outer-box {
  position: relative;
  height: 100%;
  width: 100%;
}
#container {
  height: 100vw;
  width: 100%;
  margin: 0 auto;
  position: relative;
  background: #fff !important;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
#panel {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  border-left: 1px solid #eaeaea;
  background: #fff;
  width: 100vw;
  margin: 0 auto;
  overflow: auto;
  height: calc(100vw + 95px);
}
.scrollbar1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}
.scrollbar1::-webkit-scrollbar {
  width: 6px;
  background-color: #fff;
}
.scrollbar1::-webkit-scrollbar-thumb {
  background-color: #aaa;
}
.clear {
  clear: both;
}
.tipMarker {
  font-size: 10px;
  opacity: 0.5;
  white-space: nowrap;
  display: inline-block;
}
.tipMarker:before,
.tipMarker:after {
  content: "";
}
.tipMarker.top {
  transform: translate(-50%, -110%);
}
.tipMarker.top:before,
.tipMarker.top:after {
  bottom: -9px;
  left: 0;
  right: 0;
  border-top-color: rgba(255, 254, 239, 0.8);
}
.tipMarker.top:before {
  bottom: -10px;
  border-top-color: #7e7e7e;
}
#area-tree {
  padding-left: 15px;
}
#area-tree h2 {
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  padding: 3px 5px 3px 0px !important;
  margin: 0;
  border: 1px solid #fff !important;
  border-width: 1px 3px;
  cursor: pointer;
  color: #4a4a4a;
}
#area-tree h2.lv_outside {
  border-color: #666;
  padding: 3px 10px;
}
#area-tree h2.lv_country {
  border-color: #d62728;
  padding: 3px 27px;
  margin: 0;
}
#area-tree h2.lv_province {
  border-color: #ff7f0e;
  padding: 3px 10px;
}
#area-tree h2.lv_district {
  border-color: #dd4477;
}
#area-tree ul {
  margin-left: 23px;
  clear: both;
}
#area-tree li {
  float: left;
  margin: 0;
  font-size: 12px;
  width: 100%;
}
#area-tree li.lv_province {
  margin: 0;
}
.showHideBtn {
  display: inline-block;
  position: relative;
  width: 34px;
  height: 30px;
  overflow: hidden;
  vertical-align: middle;
  margin: 0;
  cursor: pointer;
}
.showHideBtnEm {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 34px;
  overflow: hidden;
  vertical-align: middle;
  margin: 0;
  cursor: pointer;
}
@-webkit-keyframes rotate-forever {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.loading > .showHideBtn {
  -webkit-animation: 1s ease-in-out infinite rotate-forever;
}
.showHideBtn:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 10px;
  left: 10px;
  border: solid rgba(0, 0, 0, 0);
  border-width: 10px 6px;
  border-top-color: #aaa;
  transition-property: all;
  transition-duration: 0.2s;
}
.hide-sub .showHideBtn:before {
  transform-origin: 50% 20%;
  transform: rotate(-90deg);
}
.hide-sub > ul {
  display: none;
}

#area-tree > .lv_district,
#area-tree > .lv_province {
  display: none;
}
</style>
